module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landing-page-contattami/landing-page-contattami.component.scss
// module id = ./src/app/landing-page-contattami/landing-page-contattami.component.scss
// module chunks = main